import type { QuickAction, ShellConfig } from "@repo/dashboard-core";

import { languageLabels, locales } from "./locales";
import { headerActions, navItems, userMenuItems } from "./navigation";

// Brand is resolved server-side in `(dashboard)/layout.tsx` via `getServerBrand()`
// and threaded through `BrandProvider`. The dashboard shell spreads this config
// and adds the resolved `brand` from context.
export const shellConfig = {
  navItems,
  headerActions,
  userMenuItems,
  locales,
  languageLabels,
} satisfies Omit<ShellConfig, "brand">;

// CUSTOMIZE: Define quick actions for the FloatingActionButton drawer
export const quickActions: QuickAction[] = [
  {
    icon: "send",
    titleKey: "quick-actions.send-top-up",
    descriptionKey: "quick-actions.send-top-up-desc",
    href: "/library",
  },
  {
    icon: "messages",
    titleKey: "quick-actions.messages",
    descriptionKey: "quick-actions.messages-desc",
    href: "/messages",
  },
  {
    icon: "phone",
    titleKey: "quick-actions.contact",
    descriptionKey: "quick-actions.contact-desc",
    href: "/contact",
  },
];

/** GD-98 — an eSIM customer is not offered a top-up here either. */
export const esimQuickActions: QuickAction[] = quickActions.filter(
  (action) => action.titleKey !== "quick-actions.send-top-up",
);
